import axios from 'axios'

export default axios.create({
  baseURL: 'https://us-central1-eqcoop-app.cloudfunctions.net/redActiva/api/v1/',
})